import {GameTable} from '../../pixi_scene/game_scene/GameTable';
import {DynamicData} from '../../data/DynamicData';
import {Point} from 'pixi.js';
import {IPoint} from '../../interfaces/primitives/IPoint';
import {StacksHolder} from '../../pixi_scene/game_scene/game_table/table_objects/StacksHolder';
import {GameTableEvents} from '../../pixi_scene/game_scene/game_table/GameTableEvents';

export class TableController
{
    static table: GameTable;
    static holdingStacks: StacksHolder;

    /**
     * Инициализация
     * @param table - стол
     * @param holdingStacks - слой таскания колод
     */
    static start(table: GameTable, holdingStacks: StacksHolder): void {
        TableController.table = table;
        TableController.holdingStacks = holdingStacks;

        addEventListener(GameTableEvents.POSITION_AND_SCALE, TableController.applyHoldingStackPositionAndScale);
    }

    /**
     * Получение позиции центра стола
     */
    static getCenter(): Point {
        let position: Point = new Point;
        TableController.table.toLocal({
            x: Math.floor(DynamicData.sceneSizes.width / 2),
            y: Math.floor(DynamicData.sceneSizes.height / 2)
        }, void 0, position);
        return position;
    }

    /**
     * Преобразование из координат сцены в координаты слоя тоскаемых колод (равно стола)
     * @param coors - точка в координатах сцены
     */
    static globalToTable(coors: IPoint) {
        return TableController.holdingStacks.toLocal(coors);
    }

    /**
     * Обработчик внутриигрового события POSITION_AND_SCALE
     * Доблируем позицию и увеличение слоя такскания колод из стола
     * @param e - внутриигровое событие
     */
    static applyHoldingStackPositionAndScale(e: Event): void {
        TableController.holdingStacks.position = TableController.table.position;
        TableController.holdingStacks.scale = TableController.table.scale;
    }
}
